<script lang="ts" setup>
	import OrderInput from '@/components/orderinput/OrderInput.vue';
	import SubstituteButton from '@/components/substitute/SubstituteButton.vue';
	import {useSubstituteStore} from '@/store/substitutes.store';
	import type {BaseProduct} from 'dummen-shared';
	import {computed} from 'vue';
	import {useRegionStore} from '@/store/region.store';

	const props = defineProps<{
		week: number;
		year: number;
		product: BaseProduct;
		available: number;
		showSubstitutesButton: boolean;
	}>();

	const regionStore = useRegionStore();
	const substituteStore = useSubstituteStore();

	const selectedRegion = computed(() => regionStore.getSelectedRegionUrlName());

	const toggleSubstitutesModal = () => {
		substituteStore.showSubstitutesModal(selectedRegion.value, props.week, props.year, props.product);
	};

</script>

<template>
	<OrderInput :available="available"
	            :product="product"
	            :region="selectedRegion"
	            :week="week"
	            :year="year" />

	<SubstituteButton :show="showSubstitutesButton" @show-substitutes="toggleSubstitutesModal" />
</template>
